import type { GuidesDomainAnalysisDto } from '../../data-transfer-objects';

export const CallUpdatedTypes = {
  CALL_UPDATED: 'call_updated',
  CALL_CONNECTION_UPDATED: 'call_connection_updated',
  GUIDES_DOMAIN_ANALYSIS_READY: 'guides_domain_analysis_ready',
  SUGGESTED_ACTIONS_UPDATED: 'suggested_actions_updated',
} as const;

export type CallUpdatedType =
  (typeof CallUpdatedTypes)[keyof typeof CallUpdatedTypes];

/** Payload pushed when persisted GUIDE-S analysis becomes available. */
export interface GuidesDomainAnalysisReadyPayload {
  callId: number;
  guidesDomainAnalysis: GuidesDomainAnalysisDto;
}
